var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',{staticClass:"residential-template-mutate-shop",attrs:{"tag":"form"},on:{"submit":function($event){$event.preventDefault();return _vm.$emit('submit')}},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('Loader',{attrs:{"value":true,"theme":"default"}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }